const TEMP_PREFIX = "temp-";

/**
 * Checks if a message ID is a temporary ID
 * @param messageId The message ID to check
 */
export const isTemporaryMessageId = (messageId: string): boolean =>
  messageId.startsWith(TEMP_PREFIX);

/**
 * Generates a temporary message ID
 */
export const generateTemporaryMessageId = (): string =>
  `${TEMP_PREFIX}${Date.now()}`;
